import { Knot } from './Knot';
import {
  NAV_DESTINATIONS,
  KNOT_SLOT_INDEX,
  navHref,
  isGoldTab,
  type NavModelProps,
  type NavDestination,
} from './navModel';
import type { TopTab } from '../routes/route';
import './SideRail.css';

// R1a — the TABLET/DESKTOP rendering of the SAME nav model the phone
// BottomNav uses (see ../navModel). A fixed left rail: the four tab
// destinations laid out top-to-bottom with the Knot as the central capture
// action in the same middle slot the bottom bar centres it in. Active/gold
// rule identical to the bottom nav (Career is gold; everything else uses the
// ordinary active colour). The rail is pinned full-height; the content
// column beside it owns its own scroll.
export function SideRail({ active, onNavigate, knotState, onKnotPress }: NavModelProps) {
  const top = NAV_DESTINATIONS.slice(0, KNOT_SLOT_INDEX);
  const bottom = NAV_DESTINATIONS.slice(KNOT_SLOT_INDEX);
  return (
    <nav class="side-rail" aria-label="Primary">
      <div class="side-rail__brand" aria-hidden="true">V</div>
      <div class="side-rail__group">
        {top.map((item) => (
          <RailItem key={item.tab} item={item} active={active === item.tab} onNavigate={onNavigate} />
        ))}
      </div>
      <div class="side-rail__knot-slot">
        <button type="button" class="side-rail__knot-btn" aria-label="Knot" onClick={onKnotPress}>
          <Knot state={knotState} />
        </button>
      </div>
      <div class="side-rail__group">
        {bottom.map((item) => (
          <RailItem key={item.tab} item={item} active={active === item.tab} onNavigate={onNavigate} />
        ))}
      </div>
    </nav>
  );
}

function RailItem({
  item,
  active,
  onNavigate,
}: {
  item: NavDestination;
  active: boolean;
  onNavigate: (tab: TopTab) => void;
}) {
  const classes = ['side-rail__item'];
  if (active) classes.push(isGoldTab(item.tab) ? 'side-rail__item--gold' : 'side-rail__item--active');

  return (
    <a
      class={classes.join(' ')}
      href={navHref(item.tab)}
      aria-current={active ? 'page' : undefined}
      onClick={(e) => {
        e.preventDefault();
        onNavigate(item.tab);
      }}
    >
      <span class="side-rail__dot" />
      <span class="side-rail__label">{item.label}</span>
    </a>
  );
}
